<template>
    <div id="regali">
        <div class="hero hero-drops" data-aos="fade">
            <svg class="drop-gray-1" width="439" height="531" viewBox="0 0 439 531" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M322.2 0L26 296.2C10 312.2 10 338.2 26 354.3C42 370.3 68 370.3 84.1 354.3L438.4 0H322.2Z" fill="url(#paint0_linear-svg-1)"/>
                <path d="M277.9 195.1L12 460.9C-4 476.9 -4 502.9 12 519C28 535 54 535 70.1 519L336 253.1C352 237.1 352 211.1 336 195C328 187 317.5 183 307 183C296.4 183.1 285.9 187.1 277.9 195.1Z" fill="url(#paint1_linear)"/>
                <defs>
                <linearGradient id="paint0_linear-svg-1" x1="109" y1="218" x2="615" y2="-14" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                <linearGradient id="paint1_linear" x1="77.8982" y1="390.109" x2="512.043" y2="218.305" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="drop-gray-2" width="224" height="223" viewBox="0 0 224 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M223.1 111.5C223.1 173.1 173.2 223 111.6 223C49.9999 223 0.0998535 173.1 0.0998535 111.5C0.0998535 49.9 49.9999 0 111.6 0C173.2 0 223.1 49.9 223.1 111.5Z" fill="#EDF0F7"/>
            </svg>

            <div class="slider">
                <Slick ref="slick-hero-home" :options="slickOptions">
                    <div class="slide">
                        <div class="image">
                            <img class="thumb" src="img/regali/hero.png" />
                        </div>
                        <div class="caption">
                            <h1 class="text h1">
                                <!-- Con le soluzioni Vivamod puoi regalare -->
                                Regala viaggi ai tuoi dipendenti e ai tuoi clienti
                            </h1>
                            <span class="small h4">
                                in un modo innovativo, semplice e adeguato alle aspettative dell’utente contemporaneo.
                            </span>
                        </div>
                    </div>
                </Slick>

                <!--
                <div class="slider--nav">
                    <div id="hero-slider-prev" class="arrow"><SvgChevronLeft /></div>
                    <div id="hero-slider-next" class="arrow"><SvgChevronRight /></div>
                </div>
                -->
            </div>

            <ScrollTo selector="#scroll" />
        </div>

        <section class="boxed-text" data-aos="fade-up" id="scroll">
            <p class="text text-center h3">
                Il viaggio è un regalo desiderato e apprezzato specialmente oggi, quando le persone, a seguito della pandemia, attribuiscono un grande valore alla cura del proprio benessere fisico e psicologico.
            </p>
        </section>

        <section class="extraQuote" data-aos="fade-up">
            <b-container class="text-center">
                <div class="image">
                    <svg width="1545" height="811" viewBox="0 0 1545 811" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M193.076 13.8771C155.827 23.3719 119.454 37.9793 88.6328 61.059C57.8111 84.1388 33.1245 116.421 23.3375 153.524C10.6291 201.875 18.6632 252.124 4.49396 300.475C-7.33805 340.791 4.64004 384.175 35.1696 413.536C64.9687 442.167 108.353 454.583 149.546 451.223C190.739 447.864 229.887 429.751 262.753 404.48C280.136 391.187 296.204 375.703 315.778 366.062C351.566 348.241 394.512 351.747 433.222 362.118C471.932 372.489 508.888 389.142 548.182 396.592C587.476 404.041 631.591 400.974 662.559 375.703C687.683 355.253 700.83 322.824 705.212 290.688C709.595 258.698 706.235 225.1 691.627 196.47C673.952 161.85 641.962 137.018 610.556 113.938C581.487 92.6111 552.126 71.7225 520.428 54.4857C454.549 18.5514 379.174 0 303.8 0C266.551 0 229.302 4.5283 193.076 13.8771Z" fill="url(#paint0_linear-quote)"/>
                    <path d="M1483.3 811L259.646 760.878C245.043 760.878 232.241 736.373 228.04 700.262L166.43 224.882C160.028 170.199 175.931 115 198.035 115H1436.25C1450.86 115 1463.66 139.762 1467.86 175.616L1543.87 702.584C1550.27 757.267 1529.31 811 1483.3 811Z" fill="#FDC500"/>
                    <path d="M1454.45 758H258.963C226.964 758 209.729 733.512 205.529 697.425L143.935 170.808C137.535 116.162 163.97 61 223.97 61H1414.45C1445.45 61 1455.22 85.7456 1459.42 121.575L1521.01 648.192C1527.41 702.838 1502.45 758 1454.45 758Z" fill="#39414E"/>
                    <path d="M390 121.1L366.5 178.5C378 186.3 383.7 199.4 383.7 213.5C383.7 239.6 364.9 257.8 339.3 257.8C315.8 257.8 295 242.1 295 213.5C295 199.9 300.2 188.5 307 178L346.1 121.1H390ZM481.8 213.4C481.8 239.5 463 257.7 437.5 257.7C414 257.7 393.2 242 393.2 213.4C393.2 199.8 398.4 188.4 405.2 177.9L444.3 121H488.1L464.6 178.4C476.1 186.3 481.8 199.3 481.8 213.4Z" fill="white"/>
                    <defs>
                    <linearGradient id="paint0_linear-quote" x1="352.758" y1="484.869" x2="352.758" y2="59.2169" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF974F"/>
                    <stop offset="0.00128142" stop-color="#FF974F"/>
                    <stop offset="1" stop-color="#FF5652"/>
                    </linearGradient>
                    </defs>
                    </svg>                                  
                </div>
                <div class="text">
                    I consumatori oggi sono più cauti e parsimoniosi. Il consumo indiscriminato è in declino a causa dell'incertezza economica.
                    <br><br>
                    I consumatori stanno dando priorità a prodotti e servizi a valore aggiunto utili a produrre benessere psichico e fisico.
                    <br><br>
                    Per questo motivo le aziende devono orientarsi verso proposte con un chiaro valore intrinseco e percepito. 
                    <br>
                    <p class="cta text-right">
                        Top 10 global consumer trends 2021, Gina Westbrook and Alison Angus, Euromonitors International
                    </p>
                </div>
            </b-container>
        </section>

        <section class="boxed-text" data-aos="fade-up">
            <p class="text text-center h3">
                Le soluzioni Vivamod, con la loro immediatezza d’uso,
                la concretezza delle proposte di viaggio e la qualità del servizio
                di assistenza rispondono alle esigenze dell’utente contemporaneo.
            </p>
        </section>

        <b-container fluid class="valore" data-aos="fade-up">

            <svg class="top" width="957" height="316" viewBox="0 0 957 316" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M868.302 119.6C857.802 127.7 850.502 139.3 846.002 151.8C843.702 158.4 842.002 165.3 838.502 171.3C832.002 182.3 819.802 188.8 807.702 192.7C795.502 196.6 782.702 198.6 770.902 203.4C759.002 208.2 747.802 216.7 743.802 228.8C740.602 238.7 742.702 249.6 747.102 259C751.502 268.3 758.202 276.8 767.102 281.9C777.802 288.1 790.702 289.2 803.102 290C814.602 290.7 826.102 291.2 837.602 290.3C873.502 287.6 908.202 270.9 932.602 244.4C940.902 235.4 948.202 225.1 952.402 213.6C956.602 202.1 957.702 189.1 953.902 177.5C948.902 162.3 938.002 150.3 933.502 134.8C929.702 121.9 919.002 112.4 905.602 109.8C903.102 109.3 900.502 109.1 897.902 109.1C887.302 109.1 876.702 113.1 868.302 119.6Z" fill="url(#paint0_linear_top)"/>
                <path d="M87.2025 173.1C80.5025 175.7 76.2025 182.3 73.5025 188.9C70.7025 195.5 69.1025 202.7 65.4025 208.8C60.5025 217 52.0025 222.9 42.8025 225C32.1025 227.5 21.5025 224.4 11.5025 230.5C5.80249 234 1.60252 239.9 0.402517 246.5C-2.79748 264 13.7025 270.8 27.9025 275.1C33.3025 276.7 39.0025 277.2 44.7025 277.4C50.9025 277.6 57.0025 277.5 63.2025 277.3C73.6025 277.1 84.2025 276.8 94.1025 273.3C99.3025 271.4 104.103 268.7 109.203 266.5C116.203 263.4 124.402 262.4 131.202 259.2C130.402 256.9 126.203 255.3 124.303 253.5C121.603 250.9 119.503 247.7 118.203 244.2C112.603 229.5 118.203 216.1 117.703 201.2C117.403 193.1 115.002 184.8 109.502 178.8C105.402 174.5 99.5025 171.7 93.7025 171.7C91.4025 171.9 89.3025 172.3 87.2025 173.1Z" fill="url(#paint1_linear_top)"/>
                <path d="M473.803 258.2C470.503 260.9 467.802 264.3 464.102 266.4C458.802 269.4 452.402 269.2 446.602 270C439.902 270.9 433.302 272.4 427.202 275.4C420.002 278.9 413.802 285.1 410.602 292.5C408.702 297.1 408.402 302.8 411.202 307C413.702 310.8 418.202 312.9 422.702 314C433.702 316.9 444.803 314.8 453.303 307.6C454.303 306.7 455.303 305.8 456.303 304.8C462.103 298.5 466.102 290.7 472.902 285.4C479.802 280 488.302 276.3 497.102 276.2C498.202 276.2 499.203 276.2 500.303 276.2C502.203 276.3 504.102 276.3 506.002 276.1C508.902 275.7 511.903 274.6 513.703 272.2C515.603 269.6 515.503 265.9 514.203 263C512.903 260.1 510.402 257.8 507.702 256.1C503.202 253.2 497.802 251.8 492.402 251.8C485.602 251.9 478.903 254 473.803 258.2Z" fill="url(#paint2_linear_top)"/>
                <path d="M683.802 0C674.202 0.2 665.202 4.70001 656.602 9.20001C641.502 17 626.402 24.9 611.202 32.7C580.802 48.4 546.402 64.6 513.802 54.5C495.902 48.9 481.202 36.1 464.002 28.6C446.802 21.1 423.402 20.9 412.702 36.3C407.202 44.2 406.402 54.5 401.202 62.6C394.602 73 382.102 78.1 370.002 79.6C362.802 80.5 355.502 80.4 348.202 80.3C343.202 80.2 338.302 80.2 333.302 80.4C329.702 80.6 325.802 81 322.902 83.2C319.002 86.1 317.702 91.4 317.402 96.3C316.502 114.7 327.102 132.2 341.602 143.5C356.102 154.8 374.102 160.6 392.002 164.7C457.202 179.5 525.202 172.8 589.102 155.1C621.102 146.2 652.302 134.5 682.702 121.2C699.902 113.6 721.602 106.9 730.102 88.5C743.002 60.6 736.702 26.7 710.902 9.59998C702.902 4.29998 693.802 0 684.302 0C684.202 0 684.002 0 683.802 0Z" fill="url(#paint3_linear_top)"/>
                <defs>
                <linearGradient id="paint0_linear_top" x1="849.019" y1="304.101" x2="849.019" y2="132.915" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear_top" x1="65.4635" y1="285.264" x2="65.4635" y2="185.57" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint2_linear_top" x1="462.036" y1="319.91" x2="462.036" y2="260.118" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint3_linear_top" x1="526.53" y1="185.501" x2="526.53" y2="22.6552" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg> 

            <svg class="down" width="1464" height="144" viewBox="0 0 1464 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M66.1225 2.35313C53.2225 4.95313 40.9225 10.6531 30.5225 18.6531C18.1225 28.1531 8.42247 40.8531 3.42247 55.6531C-7.57753 88.3531 8.52246 131.253 43.3225 141.353C75.9225 150.753 113.222 130.853 119.122 96.5531C122.322 77.7531 124.822 59.6531 144.122 50.8531C148.022 49.0531 152.222 47.8531 156.122 45.7531C177.022 34.4531 144.822 18.1531 135.522 13.2531C120.022 5.15312 102.522 0.453125 85.0225 0.453125C78.7225 0.453125 72.3224 1.05313 66.1225 2.35313Z" fill="url(#paint0_linear_down)"/>
                <path d="M1366.57 27.5531C1363.37 28.0531 1360.88 30.6531 1359.78 33.6531C1358.68 36.6531 1358.87 40.0531 1359.57 43.1531C1362.17 54.8531 1372.87 64.3531 1384.87 65.4531C1389.07 65.8531 1393.47 65.3531 1397.47 66.4531C1403.37 68.0531 1407.67 72.7531 1412.37 76.3531C1417.77 80.4531 1423.57 84.0531 1429.97 86.2531C1437.57 88.8531 1446.28 88.9531 1453.78 85.8531C1458.38 83.9531 1462.57 80.1531 1463.57 75.2531C1464.47 70.7531 1462.77 66.1531 1460.47 62.1531C1454.77 52.3531 1445.37 45.9531 1434.37 45.0531C1433.07 44.9531 1431.68 44.9531 1430.28 44.9531C1421.78 45.2531 1413.38 47.9531 1404.78 46.9531C1396.08 45.9531 1387.47 42.5531 1381.07 36.3531C1378.97 34.2531 1377.08 31.9531 1374.78 30.1531C1372.78 28.5531 1370.28 27.4531 1367.78 27.4531C1367.48 27.4531 1367.07 27.4531 1366.57 27.5531Z" fill="url(#paint1_linear_down)"/>
                <defs>
                <linearGradient id="paint0_linear_down" x1="81.352" y1="154.178" x2="81.3519" y2="19.2274" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint1_linear_down" x1="1411.3" y1="92.6437" x2="1411.3" y2="35.4148" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="left" width="228" height="479" viewBox="0 0 228 479" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M74.7999 451C55.6999 474.6 29 484.2 0 475V44.6104C7.33642 40.4863 14.7283 36.4635 22.2 32.6002C41 22.9002 60.5 14.0002 81.2 9.4002C135.1 -2.6998 201.5 -11.0999 223.1 52.0001C231.2 75.8 228.7 102.9 216.3 124.7C194.6 162.8 154.5 172.3 124.3 200C98.0999 224.1 81.0999 258.6 80.2999 294.4C79.6999 321.2 87.2999 347.5 90.4999 374.2C93.6999 400.9 91.6999 430.1 74.7999 451Z" fill="url(#paint0_linear_left)"/>
                <defs>
                <linearGradient id="paint0_linear_left" x1="113.652" y1="513.449" x2="113.651" y2="63.5174" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <svg class="right" width="151" height="761" viewBox="0 0 151 761" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M63.9866 26.9161C29.4133 54.5284 10.1543 98.6152 8.06603 142.934C5.9777 187.021 19.6678 231.108 41.7112 269.393C53.313 289.581 67.4671 308.84 75.1243 330.883C89.0465 371.257 79.301 416.272 62.8264 455.718C46.3519 495.164 23.6124 532.058 10.3864 572.664C-3.07169 613.27 -5.85612 660.374 16.6513 696.803C34.7501 726.272 67.2351 744.602 100.88 753.884C117.123 758.293 134.061 760.845 151 760.845V0.464071C147.287 0.232035 143.807 0 140.094 0C112.946 0 86.03 9.28143 63.9866 26.9161Z" fill="url(#paint0_linear_right)"/>
                <defs>
                <linearGradient id="paint0_linear_right" x1="75.3414" y1="816.608" x2="75.34" y2="99.732" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>            

            <section>
                <div class="paragraph text-center h3">
                    <h2>Regalare viaggi si scontra, spesso, con molte complessità:</h2>
                </div>

                <div class="boxes yellow">
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">Occorre individuare i gusti del destinatario</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">I budget richiesti hanno soglie di accesso alte</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">I budget richiesti hanno scarsa granularità e significative discontinuità</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                    <div class="box">
                        <div class="content">
                            <span class="alt">></span><h3 class="text">La difficoltà di gestire un eventuale alto numero di destinatari come nel caso dei regali ai dipendenti di medie e grandi aziende</h3>
                        </div>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="#FDC500"/>
                        </svg>
                    </div>
                </div>

                <br><br>

                <a class="btn btn-lg">
                    <span>scopri di più</span>
                    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                        <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                        <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                    </svg>                            
                </a>

                <div class="boxed-text">
                    <p class="text">
                        In breve, se per le aziende regalare viaggi significa da sempre fare colpo sul destinatario e assicurarsene la fedeltà, l’obiettivo e la sua realizzazione sono spesso separati dalle sabbie della complessità.
                    </p>
                </div>

                <br><br>

                <h2 class="section--title white">La soluzione Vivamod</h2>

                <div class="boxed-text">
                    <p class="text">
                        Vivamod ti permette di attribuire ai destinatari dei tuoi regali un credito travel digitale spendibile liberamente e in base ai propri gusti e alle proprie esigenze personali, su un sito di travel booking caratterizzato da standard d’usabilità del tutto paragonabili a quelli dei giganti del settore quali Booking o Expedia.
                    </p>
                </div>

                <div class="boxes">                    
                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">Grazie alla sua <b>flessibilità e versatilità</b> d’uso un credito travel Vivamod ha un grande <b>valore percepito</b></span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                          <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                          <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                              <stop offset="0.00128142" stop-color="#FF974F"/>
                              <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                          </defs>
                        </svg>
                    </div>

                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">
                                Il valore del tuo <b>regalo è integrabile</b> dal destinatario con totale flessibilità utilizzando la sua carta di credito
                            </span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">
                                Ti permette di fare la tua operazione in un ambiente web <b>integrato con la brand identity aziendale</b>
                            </span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">
                                Con dei contenuti travel sintonizzati sui tuoi <b>valori aziendali</b>
                            </span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>

                    <div class="box">
                        <p class="content">
                            <span class="alt">></span><span class="text">
                                Con soluzioni <b>integrate alle tue piattaforme IT</b> quali intranet, app o siti web
                            </span>
                        </p>
                        <svg width="1098" height="69" viewBox="0 0 1098 69" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                            <path d="M68.0584 0C30.4361 0 0 30.4994 0 68.2H1029.54C1067.16 68.2 1097.6 37.7006 1097.6 0H68.0584Z" fill="url(#paint0_linear_box)"/>
                            <defs>
                            <linearGradient id="paint0_linear_box" x1="0" y1="34.1" x2="1097.6" y2="34.1" gradientUnits="userSpaceOnUse">
                            <stop offset="0.00128142" stop-color="#FF974F"/>
                            <stop offset="1" stop-color="#FF5652"/>
                            </linearGradient>
                            </defs>
                        </svg>
                    </div>

                </div>

                <br><br>
                <br><br>

                <div class="boxed-text">
                    <p class="text">
                        La soluzione Vivamod porta il viaggio regalo aziendale in una dimensione moderna adeguata alle aspettative delle persone preziose per la tua azienda.
                    </p>
                </div>

                <br><br>


            </section>

        </b-container>

        <section class="mt-0 pt-0">
            <b-container fluid>

                <div class="boxed-text text-center mb-0 pb-0" data-aos="fade-up">
                    <h2 class="title">
                        Per i dipendenti e i lavoratori
                    </h2>
                    <br>
                    <p class="text">
                        Vivamod offre un grande valore aggiunto anche in operazioni di elevata
                        dimensione permettendo di gestire con semplicità migliaia di regali
                    </p>
                </div>

                <div class="b-cards">

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-1.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Distribuzione digitale</h3>
                            <p class="b-card--link">
                                Il credito travel Vivamod può essere distribuito via email, con grande semplicità e in totale rispetto della privacy dei tuoi dipendenti
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-2.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Opzione gift card</h3>
                            <p class="b-card--link">
                                Può essere distribuito sotto forma di tradizionali card in cartoncino o PVC standard o brandizzate
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-3.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Integrabile con carta</h3>
                            <p class="b-card--link">
                                Il credito travel Vivamod è integrabile dal destinatario con la sua carta di credito garantendogli una totale flessibilità d’uso
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-4.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Piccolo taglio</h3>
                            <p class="b-card--link">
                                Grazie alla possibilità di integrazione da parte del destinatario puoi effettuare grandi operazioni con valori unitari contenuti
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-5.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Integrazione IT</h3>
                            <p class="b-card--link">
                                Con costi davvero contenuti è possibile realizzare un ambiente web totalmente integrato con la brand identity aziendale
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-6.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Personalizzabile in scala</h3>
                            <p class="b-card--link">
                                Possono essere realizzate soluzioni personalizzate in scala come regali di compleanno o regali aziendali di Natale per centinaia o migliaia di lavoratori
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>


                </div>


                <div class="boxed-text text-center mb-0 pb-0" data-aos="fade-up">
                    <h2 class="title">
                        Per i clienti e i partner d’affari
                    </h2>
                    <br>
                    <p class="text">
                        Quando hai necessità di realizzare regali di grosso valore per partner e clienti business importanti, per una occasione speciale o semplicemente come regalo di Natale, Vivamod ti propone crediti travel di valore significativo
                    </p>
                </div>

                <div class="b-cards">

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-7.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Regali di valore</h3>
                            <p class="b-card--link">
                                Concreti e cost effective
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                    <div class="b-card" fluid data-aos="fade-up">
                        <div class="b-card--thumb" style="background-image:url('../../../../img/regali/card-8.png')"></div>
                        <div class="b-card--text">
                            <h3 class="b-card--title">Tu regali, l’altro sceglie</h3>
                            <p class="b-card--link">
                                Non dovrai fare difficili scelte sui gusti del destinatario in quanto la scelta del viaggio è demandata totalmente alle sue scelte e alle sue preferenze.
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                    <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                    <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                </svg>                            
                            </p>
                        </div>
                    </div>

                </div>

            </b-container>
        </section>

        <section class="section--card-cofanetti" data-aos="fade-up">
            <b-container fluid>
                <h2 class="title text-center h2">Box e card</h2>
                <div class="content">
                    <img class="bg" src="img/cards-bg.svg" />
                    <img class="cards" src="img/cards.png" />
                </div>
                <!--<div class="link"><a href="#" class="btn">Scopri di più</a></div>-->
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        Sebbene Vivamod sia una soluzione nativa digitale ti offriamo anche la possibilità di creare supporti come box o card dal design moderno e, soprattutto, coordinati con la tua brand identity aziendale
                    </div>
                </div>
            </b-container>
        </section>

        <section class="boxed-text text-center mb-0 pb-0" data-aos="fade-up">
            <h2 class="title h2">
                La sicurezza delle soluzioni Vivamod
            </h2>
            <br>
            <p class="text">
                La nostra azienda è leader nella fornitura di soluzioni di travel booking per il welfare aziendale. Le aziende più innovative e prestigiose d’Italia ci affidano ogni anno centinaia di migliaia di loro lavoratori e milioni di euro di budget.
            </p>

            <br><br><br><br>

            <p class="text h4 mt-4">
                Ecco i plus delle nostre soluzioni online
            </p>
        </section>

        <section class="section--card-with-background">
            <img class="floatingImg" src="img/regali/card-bg.png" />
            <div class="content">
                <div class="card">
                    <div class="icon"><img src="img/regali/icon-1.svg"/></div>
                    <div class="title">Assistenza multicanale</div>
                    <p class="text">
                        Soluzioni supportate da un sistema di customer care multicanale gestito da personale interno all’azienda che supporta i beneficiari dei tuoi regali in modo efficace e diretto come lo fa ogni giorno con i dipendenti di primarie aziende italiane e multinazionali.
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/regali/icon-2.svg"/></div>
                    <div class="title">La privacy dell’utente</div>
                    <p class="text">
                        Soluzioni che garantiscono alti livelli di riservatezza e privacy con un sistema rodato sugli standard più avanzati.
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/regali/icon-3.svg"/></div>
                    <div class="title">UX for the masses</div>
                    <p class="text">
                        Soluzioni user friendly adatte anche ad utenze meno abituate a prenotare viaggi online
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/regali/icon-4.svg"/></div>
                    <div class="title">Oltre 500mila strutture</div>
                    <p class="text">
                        Soluzioni che permettono di accedere alle disponibilità in tempo reale di oltre 500.000 hotel, appartamenti e B&B in Italia e nel mondo
                    </p>
                </div>
            </div>
        </section>

        <b-container data-aos="fade-up">
            <section>
                <FormContatti
                    formTitle="Contattaci"
                    formSubtitle="I plus delle nostre soluzioni online"
                />
            </section>
        </b-container>

        <section class="section--prefooter" data-aos="fade-up">
            <b-container fluid>
                <b-row>
                    <b-col sm="6">
                        <div class="content">
                            <h4 class="subtitle">
                                Il regalo aziendale è uno strumento per mostrare gratitudine verso collaboratori e clienti.
                            </h4>
                            <div class="text">
                                <p>
                                    La sua originalità e personalizzazione sono importanti ma anche il tempismo ha un suo ruolo.
                                </p>
                                <p>
                                    Il Natale è ovviamente il momento più consueto ma ci sono aziende che scelgono, ad esempio, il compleanno o il San Valentino. La fantasia può sbizzarrirsi ma la scelta di un momento originale permette all’azienda di comunicare attenzione verso il destinatario e comunicazione dei valori aziendali.
                                </p>
                                <p>
                                    La scelta di cosa donare dipende dal tipo di azienda, dal messaggio da comunicare e dalla vostra filosofia e mission, come anche dal budget a disposizione. 
                                </p>
                                <p>
                                    L’ultima tendenza è quella di regalare gift card: ce ne sono di ogni genere, ogni grande brand mette a disposizione gift card e queste possono essere sia digitali che materiali. Le gift card hanno il vantaggio di essere di facile gestione da parte del donatore e di fornire al destinatario del regalo un valore tangibile e concreto, flessibile nel suo utilizzo.
                                    Il fenomeno delle gift card che, in fin dei conti non sono altro che credito ha permesso ai viaggi un rientro in grande stile dentro questo tipo di piani.
                                </p>
                                <p>
                                    Se si esclude la parentesi pandemica, cofanetti viaggio, voucher elettronici, travelcard, stanno, infatti, contendendo spazio a card focalizzate su beni di consumo ed elettronica.
                                </p>
                                <p>
                                    Indubbiamente la vera ultima tendenza in fatto di regalistica aziendale è la personalizzazione in scala. Facile indovinare i gusti quando si fanno regali prestigiosi ad alcuni partner d’affari. Impossibile, fino a ieri, farlo quando invece si tratta di regali a migliaia di dipendenti.
                                </p>
                                <p>
                                    Se fino a ieri la massificazione era obbligata oggi la tecnologia apre prospettive affascinanti nella possibilità di personalizzare i regali anche in operazioni di grande scala.
                                </p>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <div class="image">
                            <div class="image" style="background-image:url('../../../../img/regali/prefooter.jpg')"></div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>

    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import FormContatti from '@/components/blocks/form-contatti'
    import ScrollTo from '@/components/atoms/scroll-to'
    //import SvgChevronLeft from '@/components/svg/chevron-left'
   // import SvgChevronRight from '@/components/svg/chevron-right'
    
    export default {
        name: 'concorsi',
        metaInfo: {
          title: 'Regali Aziendali - Regalare viaggi online',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Scegli le Soluzioni Vivamod per i tuoi regali aziendali creando con facilità Viaggi su misura per i tuoi dipendenti, clienti e partner.' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Scegli le Soluzioni Vivamod per i tuoi regali aziendali creando con facilità Viaggi su misura per i tuoi dipendenti, clienti e partner.' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Regali Aziendali - Regalare viaggi online | Vivamod' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Scegli le Soluzioni Vivamod per i tuoi regali aziendali creando con facilità Viaggi su misura per i tuoi dipendenti, clienti e partner.' },
          ],
        },
        components: {
            Slick,
            FormContatti,
            ScrollTo,
            //SvgChevronLeft,
            //SvgChevronRight,
        },
        data()
        {
            return {
                slickOptions: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots:false,
                    fade:true,
                    arrows:true,
                    autoplay:true,
                    speed: 1500,
                    autoplaySpeed: 5500,
                    prevArrow: '#hero-slider-prev',
                    nextArrow: '#hero-slider-next',
                    responsive: [{
                        /*
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                        */
                    }]
                },
                bSlickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left',
                        nextArrow: '#b-right',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';

    #regali
    {
        .hero-drops
        {
            width:100%;
            overflow:hidden;
            max-width:1920px;
            position:relative;

            .drop-gray-1
            {
                position:absolute;
                top:46px;
                left:25%;
                width:46px;
                height:auto;
            }

            .drop-gray-2
            {
                position: absolute;
                top: 75%;
                left: 40%;
                width: 40px;
                height: auto;
            }

            .slider
            {
                position:relative;
                &--nav
                {
                    position:absolute;
                    padding:5px;
                    bottom:0;
                    display:flex;
                    .arrow
                    {
                        cursor:pointer;
                        transition:$transition-base;
                        &:hover
                        {
                            opacity:0.7;
                        }
                        path
                        {
                            stroke:$secondary;
                        }
                    }
                    @include media-breakpoint-up(lg)
                    {
                        right:0;
                        bottom:60px;
                        left:auto;
                        .arrow
                        {
                            padding:10px 20px;
                            svg
                            {
                                height:auto;
                                width:40px;
                            }
                        }
                    }
                }
            }
            .slide
            {
                //background-size: contain;
                //background-position: center center;
                //min-height: 200px;
                width:100%;
                //border:1px solid red;
                display:flex !important; //altrimenti slick, as usual, la sovrascrive con inline-block
                justify-content: flex-end;
            }
            .image
            {
                width:55%;
                position:relative;
                margin:30px 0;
                transform:translateX((5%))
            }
            .thumb
            {
                height: auto;
                width:100%;
            }
            .caption
            {
                position:absolute;
                top:50%;
                left:0;
                width:55%;
                //transform:translateY(-50%);
                padding:$grid-gutter-width/6;
                //border:1px solid green;
            }
            .small
            {
                color:$dark-blue;
                display:none;
                //font-weight: 400;
            }
            .text
            {
                //margin:0.25rem 0;
                color:$tertiary;
            }

            @include media-breakpoint-up(sm)
            {
                margin-bottom:80px;
                .drop-gray-1
                {
                    width:65px;
                    left:18.5%;
                    top:26.5%;
                }
                .drop-gray-2
                {
                    top: 82%;
                    left: 40%;
                    width: 60px;
                }
                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    width:60%;
                    margin:0;
                    transform:translateX(5%) translateY(-3.5%);
                }
                .thumb
                {
                }
                .caption
                {
                    padding: 0;
                    padding-left:$grid-gutter-width/2;
                    font-size:16px;
                    top:auto;
                    bottom:0;
                    width:55%;
                }
                .small
                {
                    display:block;
                    //max-width:220px;
                }
                .text
                {
                    margin:0.5rem 0;
                }
            }

            @include media-breakpoint-up(lg)
            {
                .drop-gray-1
                {
                    width: 160px;
                    left: 5.5%;
                    top: 0;
                }
                .drop-gray-2
                {
                    top: 80%;
                    left: 30%;
                    width: 80px;
                }
                .caption
                {
                    bottom:auto;
                    top:50%;
                    transform: translateY(-30%);
                    width:50%;
                }
                .small
                {
                    max-width:400px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    //max-width:400px;
                }                    
            }

            @include media-breakpoint-up(xxl)
            {

                .slider
                {

                }
                .slide
                {
                }
                .image
                {
                    //width:60vw;
                    //transform:none;
                    max-width:1200px;
                    top:0px;
                }
                .thumb
                {
                    top:4px;
                }
                .caption
                {
                    padding:0;
                    margin:0 $grid-gutter-width*2;
                    //font-size:16px;
                    transform:translateY(-50%);
                }
                .small
                {
                    max-width:500px;
                    &:first-child
                    {
                        bottom:100%;
                    }
                    &:last-child
                    {
                        top:100%;
                    }
                }
                .text
                {
                    //line-height:120%;
                    margin:1rem 0;
                    //font-size:36px;
                    //max-width:500px;
                }                    
            }            
        }

        @include media-breakpoint-down(xs)
        {
            .hero-drops .text
            {
                font-size: 12px;
            }
            .hero-drops .small
            {
                display:none;
            }
        }

        .extraQuote
        {
            margin-top:0;
            padding-top:0;
            padding-bottom:0 !important;
            br + br
            {
                display:none;
            }
            @include media-breakpoint-up(sm)
            {
                br + br
                {
                    display:block;
                }
            }
            .cta
            {
                display:block;
                font-size:90%;
                margin-bottom: 0;
                margin-top:10px;
                @include media-breakpoint-up(sm)
                {
                    margin-top:30px;
                }
            }
            .text
            {
                top:38%;
                left:37.5%;
                transform:translateY(-50%);
                width:50%;
                @include media-breakpoint-down(sm)
                {
                    font-size: 11px;
                }
                @include media-breakpoint-up(sm)
                {
                    top:42%;
                }
                @include media-breakpoint-up(lg)
                {
                    top:40%;
                }
                @include media-breakpoint-up(xl)
                {
                    
                    left:42%;
                    width:30.5%;
                    top:50%;
                }
            }
        }   

        section.boxed-text
        {
            margin-bottom:140px !important;
            .text
            {
            }
        }
        
        .credito-travel
        {
            margin-bottom:0 !important;
            .title
            {
                color:$dark-blue;
                text-align: center;
                position:absolute;
                top:30%;
                padding:0 4%;
            }

            .drop
            {
                margin-top:-40px;
            }

            @include media-breakpoint-up(md)
            {
                .title
                {
                    width:100%;
                }
            }
            @include media-breakpoint-up(xl)
            {
                .title
                {
                    width:100%;
                }
                .drop
                {
                    max-width: 480px;
                    bottom:80px;
                }
            }
        }

        .section--card-with-background
        {
            @include media-breakpoint-up(sm)
            {
                .card
                {
                    width:calc(50% - #{$grid-gutter-width});
                }

                .card:nth-child(3)
                {

                }

                .card:nth-child(2),
                .card:nth-child(4)
                {
                    transform:translateY(15%);
                }
            }
            @include media-breakpoint-up(lg)
            {
                padding-top:280px;
            }
        }

        .section--prefooter
        {
            .image
            {
                background-position: top center;
            }
        }

        .b-cards
        {
            /*
            .b-card
            {
                &--thumb
                {
                    height:145px;
                }
            }
            */
        }

    }
</style>